import { render, staticRenderFns } from "./SubscriberPerformance.vue?vue&type=template&id=08ceeaac&"
import script from "./SubscriberPerformance.vue?vue&type=script&lang=js&"
export * from "./SubscriberPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports